import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/utils/services/api.service';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { LoaderService } from 'src/app/utils/services/loader.service';
import Swal from 'sweetalert2';
// import { resourceLimits } from 'worker_threads';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})

export class UserListComponent implements OnInit, OnDestroy {
  dtOptions: any = {};
  allUser: any;
  render: number;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  mobileCheck=true
  constructor(
    private apiService: ApiService, 
    private toastr: ToastrService,
    private LoaderService:LoaderService
  ) { }

  ngOnInit(): void {
   const data= localStorage.getItem('type')
   if(data=="User Panel"){
    this.mobileCheck=false
   }
   else{
    this.mobileCheck=true
   }
    this.LoaderService.showLoader()
    const that = this;

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      dom: 'Bfrtip',
      buttons: ['excel']
    };
    this.render = 1;
    this.showItem();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  async showItem() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      dom: 'Bfrtip',
      buttons: ['excel']
    };
    this.render = 1;
    // this.LoaderService.showLoader()
    const that = this;
    await this.apiService.getAllUsers().subscribe((resp: any) => {
      that.allUser = resp.data;
      if(this.render === 1) {
        this.LoaderService.hideLoader()
        this.dtTrigger.next();
      }
      this.render = 0;
    });
    // this.LoaderService.hideLoader()
  }

  async changeStatus(id, status) {
    this.LoaderService.showLoader();
  
    if (id == undefined || id == '') {
      this.toastr.error('User Id is Invalid');
      return false;
    }
  
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to change the status?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, change it!',
      cancelButtonText: 'Cancel',
    });
  
    if (result.isConfirmed) {
      let getStatus = status === 'active' ? { "status": "inactive" } : { "status": "active" };
      await this.apiService.changeStausById(id, JSON.stringify(getStatus)).subscribe((response: any) => {
        this.LoaderService.hideLoader();
  
        if (response.success) {
          this.toastr.success(response.message);
          location.reload();
          this.showItem()
        } else {
          this.toastr.error(response.message);
        }
      }, (error) => {
        this.LoaderService.hideLoader();
        this.toastr.error('Error occurred while changing the status.');
        console.error('Error details:', error);
      });
    } else {
      this.LoaderService.hideLoader(); // Hide loader if canceled
    }
  }
  async deleteUser(id) {
    this.LoaderService.showLoader();
  
    if (id == undefined || id == '') {
      this.toastr.error('User Id is Invalid');
      return false;
    }
  
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to restore this user!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });
  
    if (result.isConfirmed) {
      await this.apiService.deleteUserLoginDetails(id).subscribe((response: any) => {
        this.LoaderService.hideLoader();
  
        if (response.success) {
          this.showItem();
          location.reload()
          this.toastr.success("User deleted successfully");
        } else {
          this.toastr.error('Failed to delete user.');
        }
      }, (error) => {
        this.LoaderService.hideLoader();
        this.toastr.error('Error deleting user.');
        console.error('Error details:', error);
      });
    } else {
      this.LoaderService.hideLoader(); // Hide loader if canceled
    }
  }
    

}
